var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4192_104458)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1,
    transform: "translate(-952 -140)",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1036,
    transform: "translate(-952 -68)",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -103,
    y: 24,
    width: 567,
    height: 180,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -952,
    y: -140,
    width: 1440,
    height: 1110,
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 1110,
    transform: "translate(-24 -140)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#pattern0)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4192_104458",
    transform: "matrix(0.00313843 0 0 0.0030239 0.144961 0.160789)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4192_104458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1110,
    fill: "white",
    transform: "translate(-952 -140)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_4192_104458",
    width: 225,
    height: 225,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoft);
export default __webpack_public_path__ + "static/media/Microsoft.62b4a4faaf3516124fcc9cfef3d2983e.svg";
export { ForwardRef as ReactComponent };